import RouteParent from 'js/router/route-parent'
import AiInfinityRulesIndex from 'js/pages/ai-infinity-rules/index.js'
import AiInfinityRulesNew from 'js/pages/ai-infinity-rules/new/index.js'
import aiInfinityRulesEdit from 'js/pages/ai-infinity-rules/edit/index.js'

export default [
  {
    path: '/ai-infinity-rules',
    component: RouteParent,
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'ai-infinity-rules-list',
        component: AiInfinityRulesIndex,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN'] 
        }
      },
      {
        path: 'new',
        name: 'ai-infinity-rules-new',
        component: AiInfinityRulesNew,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      },
      {
        path: ':id/edit',
        name: 'ai-infinity-rules-edit',
        component: aiInfinityRulesEdit,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      }
    ]
  }
]